// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__2e8OS"};